import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { ScanLine } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const nav = useNavigate();
  const { setUserFromGoogle } = useAuth();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav("/login", { replace: true }); return; }
    const sessionId = decodeURIComponent(m[1]);

    (async () => {
      try {
        const r = await api.post("/auth/session", null, {
          headers: { "X-Session-ID": sessionId },
          withCredentials: true,
        });
        setUserFromGoogle(r.data.user);
        // Clean the hash and navigate to app
        window.history.replaceState(null, "", window.location.pathname);
        nav("/app", { replace: true });
      } catch {
        nav("/login?error=oauth", { replace: true });
      }
    })();
  }, [nav, setUserFromGoogle]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8F8F6]">
      <div className="text-center">
        <div className="w-12 h-12 bg-[#0A0A0A] rounded-xl mx-auto mb-4 flex items-center justify-center">
          <ScanLine className="w-5 h-5 text-white animate-pulse" />
        </div>
        <div className="font-display font-bold text-xl tracking-tight">Accesso in corso…</div>
      </div>
    </div>
  );
}
